var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCosmeticsbig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20.536pt",
    height: "20.367pt",
    viewBox: "0 0 20.536 20.367",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3e-5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.363-8.3851e-6c-3.75 3.2891-10.191 10.246-10.195 10.25l-0.16797 0.17969 0.17969 0.16797c3.0664 2.9766 6.332 6.2305 10.055 9.6172l0.16407 0.15235 0.16797-0.14844c3.7539-3.3398 6.9336-6.6523 9.8008-9.4648l0.16797-0.16407-0.15235-0.17578c-4e-3 -4e-3 -5.9922-7.1523-9.6914-10.414l-0.32813 0.375c1.8203 1.6055 4.2344 4.1992 6.1875 6.3867 0.97656 1.0938 1.8398 2.0898 2.457 2.8086 0.61719 0.71875 0.99219 1.1641 0.99219 1.1641l0.19141-0.16016-0.17579-0.17969c-2.875 2.8203-6.0469 6.125-9.7812 9.4492l0.16797 0.1875 0.16797-0.18359c-3.7109-3.3828-6.9727-6.6289-10.043-9.6094l-0.17578 0.17969 0.1836 0.17187c0-4e-3 0.40234-0.43359 1.0625-1.1367 1.9883-2.1094 6.3164-6.6367 9.0938-9.0781",
    fill: "#231f20"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCosmeticsbig);
export default __webpack_public_path__ + "static/media/cosmeticsbig.9a9b0456522e177bbd72b5a2a4dec5cd.svg";
export { ForwardRef as ReactComponent };